export class CPSearchInputParam {
    code: string = '';
    customInputCode: string = '';
    customInputValue: string = '';
    openSearch: boolean = false;
}